import { render } from "./slideout.vue?vue&type=template&id=54451338&scoped=true"
import script from "./slideout.vue?vue&type=script&setup=true&lang=ts"
export * from "./slideout.vue?vue&type=script&setup=true&lang=ts"

import "./slideout.vue?vue&type=style&index=0&id=54451338&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54451338"
/* hot reload */
if (module.hot) {
  script.__hmrId = "54451338"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54451338', script)) {
    api.reload('54451338', script)
  }
  
  module.hot.accept("./slideout.vue?vue&type=template&id=54451338&scoped=true", () => {
    api.rerender('54451338', render)
  })

}

script.__file = "resources/ts/components/elements/slideout.vue"

export default script